// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1wLGc","buttons":"SendReceipts_buttons__txRlE","email":"SendReceipts_email__2iEUd","bookApptTitle":"SendReceipts_bookApptTitle__1tsJI"};